import {createContext, useContext} from "react";

import {IUserProfile} from "../../types/IUserProfile";

export interface IUserPhoneVerificationContextValue {
    getUserProfile: () => Promise<IUserProfile | null>;
    sendPhoneVerificationCode: () => Promise<{error?: {message: string; status: number}}>;
    verifyPhone: (code: string) => Promise<{error?: {message: string; status: number}}>;
    onError?: (error: {message: string; status: number}) => void;
    hotlinePhoneNumber?: string;
}

export const UserPhoneVerificationContext = createContext<IUserPhoneVerificationContextValue | null>(null);

export const useUserPhoneVerificationContext = () => {
    const context = useContext(UserPhoneVerificationContext);
    if (!context) {
        throw new Error("useUserPhoneVerificationContext must be used within UserPhoneVerificationProvider");
    }
    return context;
};
